import { render, staticRenderFns } from "./simple-table.vue?vue&type=template&id=4665a81a"
import script from "./simple-table.vue?vue&type=script&lang=ts"
export * from "./simple-table.vue?vue&type=script&lang=ts"
import style0 from "./simple-table.vue?vue&type=style&index=0&id=4665a81a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports